import {Heading, SimpleGrid, Text} from '@chakra-ui/react';
import React from 'react';
import FlexCard from '../../../General/FlexCard';
import {CustomInput} from '../../../General/FormInputs';

const OppManager = ({register, errors}) => {
  return (
    <FlexCard w="35%">
      <SimpleGrid columns={3}>
        <Heading size="md">Manager</Heading>
        <Heading size="md">Funeral</Heading>
        <Heading size="md">Cremation</Heading>

        <Text>A/R Balance</Text>
        <CustomInput register={register} errors={errors} id="emMarbal" requireInt />
        <CustomInput register={register} errors={errors} id="emCremarm" requireInt />

        <Text>E&O</Text>
        <CustomInput register={register} errors={errors} id="emMeo" requireInt />
        <CustomInput register={register} errors={errors} id="emCremeom" requireInt />

        <Text>Max Bonus</Text>
        <CustomInput register={register} errors={errors} id="emMmaxbon" requireInt />
        <Text></Text>

        <Text>Target Rev</Text>
        <CustomInput register={register} errors={errors} id="emMtarget" requireInt />
        <Text></Text>

        <Text>Add'l Rev</Text>
        <CustomInput register={register} errors={errors} id="emArevfm" requireInt />
        <CustomInput register={register} errors={errors} id="emArevcm" requireInt />
      </SimpleGrid>
    </FlexCard>
  );
};

export default OppManager;
